<template>
  <div v-if="!loading" class="quote-block">
    <back-link :to="{ name: 'detail' }" />

    <package-summary
      class="quote-block__summary"
      :services="quote.services"
      :live_price="Number(quote.live_price)"
      :availability="availability"
      :pax_count="adults_count"
    />

    <validation-observer tag="div" v-slot="{ invalid, errors }">
      <div class="quote-block__panel">
        <h1 class="vb-heading quote-block__heading">
          Chi parteciperà al viaggio?
        </h1>
        <p class="quote-block__intro">
          Inserisci con attenzione i dati dei viaggiatori così come indicati nel
          documento di identità che verrà usato per il viaggio. Tutti i campi
          sono obbligatori.
        </p>

        <passengers-info :passengers="passengers_list" />

        <disclaimer-checkout v-model="check_disclaimer" />
      </div>

      <div class="quote-block__actions">
        <div
          v-if="invalid || !check_disclaimer"
          class="quote-block__errors"
        >
          <div v-if="invalid">Compila tutti i campi obbligatori per proseguire</div>
          <template v-if="invalid">
            <div v-for="(field_errors, field_name) in errors" :key="field_name">
              <span v-for="(err, err_index) in field_errors" :key="err_index">{{
                err
              }}</span>
            </div>
          </template>
          <div v-if="!check_disclaimer">Accetta le condizioni per proseguire</div>
        </div>

        <vb-button
          :vb_options="{
            disabled: invalid || !check_disclaimer,
            variant: 'info',
            to: { name: 'checkout' },
            icon_disabled: 'lock',
            text: 'Vai al checkout',
          }"
          @click="goto_checkout"
        />
      </div>
    </validation-observer>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import { custom_event, get_config } from '@utilities/commons';
  import { is_adult } from '@alpitour/utilities';
  import { alpitour_rybbit_event } from '@alpitour/utilities/rybbit';
  import {
    build_passengers_model,
    get_departure_date,
  } from './logic/passenger';
  import BackLink from '@alpitour/components/atoms/back-link.vue';
  import PackageSummary from './package-summary.vue';
  import PassengersInfo from './passengers-info.vue';
  import DisclaimerCheckout from './disclaimer-checkout.vue';

  export default {
    name: 'quote-block',
    components: {
      'back-link': BackLink,
      'package-summary': PackageSummary,
      'passengers-info': PassengersInfo,
      'disclaimer-checkout': DisclaimerCheckout,
    },
    props: {
      quote: {
        type: Object,
        default: () => ({}),
      },
    },
    computed: {
      ...mapState('liveat', ['selected_room', 'checkin_date', 'checkout_date']),
      passengers: {
        get() {
          return this.$store.state.liveat.passengers;
        },
        set(value) {
          this.$store.commit('liveat/passengers', value);
        },
      },
      passengers_list() {
        return (this.passengers && this.passengers.passengers) || [];
      },
      adults_count() {
        return this.passengers_list.filter(is_adult).length;
      },
      availability() {
        return this.get_availability();
      },
    },
    data() {
      return {
        loading: true,
        check_disclaimer: false,
      };
    },
    mounted() {
      this.init_passengers();
      this.loading = false;
    },
    methods: {
      init_passengers() {
        const departure_date = get_departure_date(this.quote);
        this.passengers = build_passengers_model({
          quote: this.quote,
          departure_date,
          checkin_date: this.checkin_date,
        });
      },

      goto_checkout() {
        const { quote_payload = {} } = this.selected_room || {};
        const { totAmount = 0 } = quote_payload;
        custom_event(
          'initiateCheckout',
          get_config('integration.company'),
          totAmount,
          'partnerBehaviour'
        );

        alpitour_rybbit_event('passengers-info:submit', { type: 'info' });

        this.$store.commit('liveat/quote', this.quote);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .quote-block {
    margin-bottom: $grid-gutter-width * 4;

    &__summary {
      margin-bottom: $grid-gutter-width;
    }

    &__panel {
      @extend %section__content;
      margin-top: 0;
      margin-bottom: $grid-gutter-width;
      line-height: $line-height-base;
    }

    &__heading {
      font-size: $h2-font-size;
      margin-bottom: $grid-gutter-width/3;
    }

    &__intro {
      font-size: $font-size-md;
      margin-bottom: $grid-gutter-width;
    }

    &__actions {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
    }

    &__errors {
      text-align: right;
      color: $danger;
      font-size: $font-size-sm;
      margin-bottom: $grid-gutter-width/6;
    }
  }
</style>
